"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CloseDark", {
  enumerable: true,
  get: function get() {
    return _closeIconDark.default;
  }
});
Object.defineProperty(exports, "CloseIcon", {
  enumerable: true,
  get: function get() {
    return _closeIcon.default;
  }
});
Object.defineProperty(exports, "CloseLight", {
  enumerable: true,
  get: function get() {
    return _closeIconLight.default;
  }
});
Object.defineProperty(exports, "Logo", {
  enumerable: true,
  get: function get() {
    return _logo.default;
  }
});
Object.defineProperty(exports, "ModalClose", {
  enumerable: true,
  get: function get() {
    return _modalClose.default;
  }
});
Object.defineProperty(exports, "SmallLogo", {
  enumerable: true,
  get: function get() {
    return _smallLogo.default;
  }
});
var _logo = _interopRequireDefault(require("./logo.svg"));
var _smallLogo = _interopRequireDefault(require("./small-logo.svg"));
var _modalClose = _interopRequireDefault(require("./modal-close.png"));
var _closeIconLight = _interopRequireDefault(require("./close.icon.light.png"));
var _closeIconDark = _interopRequireDefault(require("./close.icon.dark.svg"));
var _closeIcon = _interopRequireDefault(require("./close.icon.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }